import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", onClick }) {
  return (
    <Link to="/" onClick={onClick} className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="logo-link">
      <span className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground font-display font-black text-lg shadow-[0_0_24px_-6px_hsl(21_100%_50%/0.6)]">
        JD
      </span>
      <span className="font-display font-extrabold text-lg tracking-tight leading-none">
        Jonuzovic<span className="text-primary">Design</span>
      </span>
    </Link>
  );
}
